<template>
  <!-- 考试查看解析 -->
  <div class="uni-startPractice">
    <div class="leftBox">
      <i class="iconfont iconfanhui" @click="$router.go(-1)"></i>
      <div class="grade">
        {{ datas.testScore }}
        <span class="f20">分</span>
      </div>

      <div class="title f24">{{ datas.paperName }}</div>
      <div class="total-text">
        <span class="mar40" v-for="(item, key) in datas.topicTypeMap" :key="key"
          >{{ key }}{{ item.questionNumber }}题 共{{
            item.questionScore
          }}分</span
        >
        <span class="mar40">得分{{ datas.passScore }}分及格</span>
      </div>

      <div :class="fontClass">
        <!-- 填空题 -->
        <FillBlank
          v-if="currentQuestion.questionType == '填空题'"
          :index="currentIndex"
          :datas="currentQuestion"
          :isDisabled="isDisabled"
        />
        <!-- 单选题 -->
        <ChoiceOne
          v-if="currentQuestion.questionType == '单选题'"
          :index="currentIndex"
          :datas="currentQuestion"
          :isDisabled="isDisabled"
        />
        <!-- 多选题 -->
        <ChoiceMultiple
          v-if="currentQuestion.questionType == '多选题'"
          :index="currentIndex"
          :datas="currentQuestion"
          :isDisabled="isDisabled"
        />
        <!-- 判断题 -->
        <Judge
          v-if="currentQuestion.questionType == '判断题'"
          :index="currentIndex"
          :datas="currentQuestion"
          :isDisabled="isDisabled"
        />
        <!-- 简答题 -->
        <Subjective
          v-if="!['填空题', '单选题', '多选题', '判断题'].includes(currentQuestion.questionType)"
          :index="currentIndex"
          :datas="currentQuestion"
          :isDisabled="isDisabled"
        />

        <div class="submit mat20" v-if="currentIndex != datas.topicList.length">
          <div @click="next(false)">下一题</div>
        </div>

        <!-- 解析 -->
        <QuestionAnalysis
          :analysisDatas="currentQuestion"
          @collectChange="updateCollect"
        />
      </div>
    </div>

    <div class="mat20">
      <AnswerSheet
        :isAnalysis="true"
        :currentId="currentQuestion.id"
        :datas="datas"
        @change="jumpTo"
        @submit="submit"
      ></AnswerSheet>
    </div>
  </div>
</template>

<script>
import AnswerSheet from "@/components/answerSheet";
import ChoiceOne from "@/views/business/questionType/questionChoiceOne";
import FillBlank from "@/views/business/questionType/questionFillBlank";
import Judge from "@/views/business/questionType/questionJudge";
import ChoiceMultiple from "@/views/business/questionType/questionChoiceMultiple";
import Subjective from "@/views/business/questionType/questionSubjective";
import QuestionAnalysis from "@/views/business/questionType/questionAnalysis";
import { getExamPaperAlalysis } from "@/api/realTest";
import { mapState } from "vuex";

export default {
  name: "uni-startPractice",
  computed: {
    ...mapState("common", {
      fontClass: (state) => state.fontClass,
    }),
  },
  components: {
    AnswerSheet, //工具栏
    QuestionAnalysis, //解析
    ChoiceOne, //单选
    FillBlank, //填空
    Judge, //判断
    ChoiceMultiple, //多选
    Subjective, //简答
  },
  data() {
    return {
      isDisabled: true,
      // 路由参数
      paperUuid: "", //试卷id
      // examUuid: "", //考试id
      // 分数弹框
      scoreDialog: {
        title: "",
        score: 0,
        icon: "",
        isScoreVisible: false,
        showCancelBtn: true,
      },
      // 题目集合
      datas: {
        topicList: [],
      },
      // 当前题目
      currentQuestion: {}, //题目
      currentIndex: 1, //索引
    };
  },
  // 挂载结束状态
  mounted() {
    this.paperUuid = this.$route.query.paperUuid;
    // this.examUuid = this.$route.query.examUuid;

    this.getAnalysisDetail().then(() => {
      // 初始化第一道题
      if (this.datas.topicList && this.datas.topicList.length > 0) {
        this.resetCurrent(0);
      }
    });
  },
  methods: {
    /**
     * 练习题请求
     */
    async getAnalysisDetail() {
      const params = {
        paperUuid: this.paperUuid,
        // paperUuid: "d6ee4592-10e7-11eb-b8f5-46c8b750b56a",
      };
      const datas = await getExamPaperAlalysis(params);
      if (datas) {
        datas.topicList = datas.topicList.map((item) => {
          switch (item.questionType) {
            case "单选题":
            case "多选题":
            case "判断题":
              item.studentAnswerList = item.studentAnswerList.map((item2) => {
                return JSON.stringify(item2);
              });
              break;
            case "填空题":
              item.studentAnswerList =
                item.studentAnswerList.length > 0
                  ? item.studentAnswerList
                  : item.answerList.map((item2) => {
                      item2.name = "";
                      return item2;
                    });
              break;
            default:
              //简答题等
              item.studentAnswerList =
                item.studentAnswerList.length > 0
                  ? item.studentAnswerList
                  : [
                      {
                        name: "",
                        path: [],
                      },
                    ];
              break;
          }

          return item;
        });
        this.datas = datas;
      }
    },
    /**
     * 重置当前题目
     * currentIndex: 当前题的索引
     */
    resetCurrent(currentIndex) {
      const topic = this.datas.topicList[currentIndex];
      this.currentQuestion = topic;
      this.currentIndex = currentIndex + 1;
    },
    /**
     * 下一题
     */
    next() {
      this.resetCurrent(this.currentIndex);
    },
    /**
     * 点击答题卡到当前题
     */
    jumpTo(id) {
      const topic = this.datas.topicList;
      for (let i = 0; i < topic.length; i++) {
        let item = topic[i];
        if (item.id == id) {
          this.resetCurrent(i);
        }
      }
    },
    /**
     * 更新datas的当前题收藏状态
     */
    updateCollect(val) {
      this.datas.topicList[this.currentIndex - 1].isCollect = val;
    },
    /**
     * 提交
     */
    submit() {
      this.$router.go(-2);
      // this.$router.replace({
      //   name: "allTest",
      // });
    },
  },
};
</script>

<style lang="scss">
.el-radio__input.is-disabled + span.el-radio__label {
  color: #666;
}
</style>
<style lang="scss" scoped>
.uni-startPractice {
  display: flex;
  .iconfanhui {
    color: #999999;
    font-size: 38px;
    &:hover {
      color: #666666;
    }
  }
  .spanColor {
    color: #666666;
    font-size: 14px;
  }
  .leftBox {
    background-color: #ffffff;
    flex: 1;
    padding: 20px 40px;
    margin: 20px;
    margin-bottom: 0;

    .grade {
      float: right;
      min-width: 142px;
      height: 63px;
      line-height: 63px;
      background: #e64040;
      color: #fff;
      font-size: 32px;
      text-align: center;
      margin-top: -20px;
    }
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 18px;
        color: #000;
        font-weight: 400;
        &:first-child {
          font-size: 20px;
          font-weight: 700;
        }
      }
      em {
        margin: 0 14px;
        display: flex;
        height: 26px;
        width: 1px;
        background: $gray;
      }
    }

    .total-text {
      display: flex;
      justify-content: center;
      color: $grayLight;
      margin-top: 20px;
      padding: 10px 0;
      border-bottom: 1px solid $grayLight2;
    }

    .clear {
      margin: 65px 60px 0 60px;
      height: 1px;
      border: 1px dashed #e8e8e8;
    }
    .speed {
      padding-bottom: 52px;
      border-bottom: 1px dashed #e8e8e8;
      .text {
        color: #9a9a9a;
        font-size: 14px;
        margin: 30px 0 20px 0;
      }
      .strip {
        display: flex;
        align-items: center;
        .box {
          flex: 1;
        }
        .textBox {
          margin-left: 32px;
          span {
            font-size: 14px;
            color: #9a9a9a;
            &:first-child {
              color: #f38829;
            }
          }
          em {
            font-style: normal;
            margin: 0 10px;
            color: #9a9a9a;
          }
        }
      }
    }

    .submit {
      display: flex;
      justify-content: flex-end;
      div {
        @include uni-button;
        @include bgColor("primary");
      }
    }
  }
}
</style>
